import React, { useState, useRef } from 'react'
import './styles.scss'
import { connect } from 'react-redux'
import { ReactComponent as AppleIcon } from '../../../assets/media/icons/icon-apple.svg'
import { ReactComponent as BottleIcon } from '../../../assets/media/icons/icon-bottle.svg'
import { ReactComponent as SleepIcon } from '../../../assets/media/icons/icon-sleep.svg'
import { ReactComponent as MusicIcon } from '../../../assets/media/icons/icon-music.svg'
import { ReactComponent as IDCardIcon } from '../../../assets/media/icons/icon-id-card.svg'
import { ReactComponent as SSNCardIcon } from '../../../assets/media/icons/icon-ssn-card.svg'
import { ReactComponent as MsgSearchIcon } from '../../../assets/media/icons/icon-msg-search.svg'
import { ReactComponent as CalendarTimeIcon } from '../../../assets/media/icons/icon-cal-time.svg'
import { ReactComponent as HandshakeIcon } from '../../../assets/media/icons/icon-handshake.svg'
import { ReactComponent as MedExamIcon } from '../../../assets/media/icons/icon-med-exam.svg'
import { ReactComponent as PressureCuffIcon } from '../../../assets/media/icons/icon-pressure-cuff.svg'
import { ReactComponent as TimeIcon } from '../../../assets/media/icons/icon-time.svg'
import { ReactComponent as SalineIcon } from '../../../assets/media/icons/icon-saline.svg'
import { ReactComponent as HandMoneyIcon } from '../../../assets/media/icons/icon-hand-money.svg'
import { ReactComponent as TwoHeartsIcon } from '../../../assets/media/icons/icon-two-hearts.svg'
import { ReactComponent as CloseIcon } from '../../../assets/media/icons/button-close-large-orange.svg'
import importer from '@takedapdt/biolife-core/src/importer'
import { devices } from '../../utils/styledComponentHelpers'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { ReactComponent as NextArrow } from '../../../assets/media/icons/circle-arrow-right-white.svg'
import { ReactComponent as PrevArrow } from '../../../assets/media/icons/circle-arrow-left-white.svg'
const { useScreenSize } = importer('Contexts/ResponsiveContextProvider', null)
const loyaltyActions = importer('Stores/Loyalty/Actions')

const SliderNextArrow = ({ className, onClick, color }) => {
  return <NextArrow width={'32'} height='32' className={`${className} custom-arrow ${color}`} onClick={onClick} />
}

const SliderPrevArrow = ({ className, onClick, color }) => {
  return <PrevArrow width='32' height='32' className={`${className} custom-arrow ${color}`} onClick={onClick} />
}

const StyledCloseIcon = styled(CloseIcon)`
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: pointer;
  width: 31px;
  height: 31px;
  path:last-child {
    fill: ${(props) => props.$textColor};
  }
  ${devices.mobile} {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
    width: 28px;
    height: 28px;
    path:last-child {
      fill: ${(props) => props.$textColor};
    }
  }
`

const LoyaltyGameWhatToExpectModal = ({ onClose }) => {
  const { t, i18n } = useTranslation('LoyaltyGameWhatToExpectModal')
  const slider = useRef(null)
  const { isMobileWidth, isTabletWidth } = useScreenSize()
  const [isAnimating, setIsAnimating] = useState(true)
  const [animationClass, setAnimationClass] = useState('fadeIn')

  const carouselItems = [
    {
      screenTitle: t('gearup'),
      screenTitleColor: `var(--color-white)`,
      screenBgColor: `var(--color-dark-focus-blue)`,
      closeIconColor: 'white',
      cardItems: {
        cards: [
          {
            icon: <SleepIcon width={isMobileWidth ? 62 : 62} height={isMobileWidth ? 62 : 62} />,
            title: t('restup'),
            desc: t('sleepWellNightBefore'),
            color: `var(--color-white)`
          },
          {
            icon: <BottleIcon width={isMobileWidth ? 62 : 62} height={isMobileWidth ? 62 : 62} />,
            title: t('fuelup'),
            desc: t('drinkPlentyWater'),
            color: `var(--color-white)`
          },
          {
            icon: <AppleIcon width={isMobileWidth ? 62 : 62} height={isMobileWidth ? 62 : 62} />,
            title: t('powerup'),
            desc: t('eatHealthyMeal'),
            color: `var(--color-white)`
          }
        ]
      },
      proTipItem: {
        icon: <MusicIcon width={isMobileWidth ? 62 : 62} height={isMobileWidth ? 62 : 62} />,
        title: t('proTip'),
        desc: t('packyourFav')
      }
    },
    {
      screenTitle: t('bringIt'),
      screenTitleColor: `var(--color-dark-focus-blue)`,
      screenBgColor: `var(--color-white)`,
      closeIconColor: 'grey',
      cardItems: {
        cards: [
          {
            icon: <IDCardIcon width={isMobileWidth ? 62 : 62} height={isMobileWidth ? 62 : 62} />,
            title: t('govermentId'),
            desc: t('photoId'),
            color: `var(--color-rich-black)`
          },
          {
            icon: <SSNCardIcon width={isMobileWidth ? 62 : 62} height={isMobileWidth ? 62 : 62} />,
            title: t('socialSecurityNumber'),
            desc: t('officalDoc'),
            color: `var(--color-rich-black)`
          },
          {
            icon: <MsgSearchIcon width={isMobileWidth ? 62 : 62} height={isMobileWidth ? 62 : 62} />,
            title: t('proofAddress'),
            desc: t('recentBill'),
            color: `var(--color-rich-black)`
          }
        ]
      },
      proTipItem: {
        icon: <CalendarTimeIcon width={isMobileWidth ? 62 : 62} height={isMobileWidth ? 62 : 62} />,
        title: t('proTip'),
        desc: t('arriveEarly')
      }
    },
    {
      screenTitle: t('letsGo'),
      screenTitleColor: `var(--color-white)`,
      screenBgColor: `var(--color-dark-focus-blue)`,
      closeIconColor: 'white',
      cardItems: {
        cards: [
          {
            icon: <HandshakeIcon width={isMobileWidth ? 62 : 62} height={isMobileWidth ? 62 : 62} />,
            title: t('meetStaff'),
            desc: t('guideProcess'),
            color: `var(--color-white)`
          },
          {
            icon: <MedExamIcon width={isMobileWidth ? 62 : 62} height={isMobileWidth ? 62 : 62} />,
            title: t('getScreened'),
            desc: t('quickHealth'),
            color: `var(--color-white)`
          },
          {
            icon: <PressureCuffIcon width={isMobileWidth ? 62 : 62} height={isMobileWidth ? 62 : 62} />,
            title: t('checkVitals'),
            desc: t('checkWeight'),
            color: `var(--color-white)`
          }
        ]
      },
      proTipItem: {
        icon: <TimeIcon width={isMobileWidth ? 62 : 62} height={isMobileWidth ? 62 : 62} />,
        title: t('proTip'),
        desc: t('bePatientText')
      }
    },
    {
      screenTitle: t('youGolden'),
      screenTitleColor: `var(--color-dark-focus-blue)`,
      screenBgColor: `var(--color-white)`,
      closeIconColor: 'grey',
      cardItems: {
        cards: [
          {
            icon: <SalineIcon width={isMobileWidth ? 62 : 62} height={isMobileWidth ? 62 : 62} />,
            title: t('relaxDonate'),
            desc: t('sitBack'),
            color: `var(--color-rich-black)`
          },
          {
            icon: <HandMoneyIcon width={isMobileWidth ? 62 : 62} height={isMobileWidth ? 62 : 62} />,
            title: t('getPayment'),
            desc: t('receiveCompenstationText'),
            color: `var(--color-rich-black)`
          },
          {
            icon: <TwoHeartsIcon width={isMobileWidth ? 62 : 62} height={isMobileWidth ? 62 : 62} />,
            title: t('dontaionMatters'),
            desc: t('savingLives'),
            color: `var(--color-rich-black)`
          }
        ]
      },
      proTipItem: {
        icon: <BottleIcon width={isMobileWidth ? 62 : 62} height={isMobileWidth ? 62 : 62} />,
        title: t('proTip'),
        desc: t('rehydrates')
      }
    }
  ]

  const [arrowColor, setArrowColor] = useState(carouselItems[0].closeIconColor)

  const afterChangeHandler = (current) => {
    setAnimationClass('fadeIn')
    setIsAnimating(true)
    setTimeout(() => {
      setIsAnimating(false)
    }, 6000) // Delay to ensure all carouselItemIcon items are reloaded
    setArrowColor(carouselItems[current].closeIconColor)
  }

  const beforeChangeHandler = (current, next) => {
    document.getElementById('modal-content').scrollTo(0, 0)
    setAnimationClass('')
    setTimeout(() => {
      setAnimationClass('fadeIn')
    }, 100) // Reset animation class after fade out
  }

  var settings = {
    dots: true,
    intialSlide: 0,
    infinite: false,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    screenBgColor: `var( --color-primary-white)`,
    arrows: isMobileWidth ? false : true,
    nextArrow: <SliderNextArrow className='iconImage' color={isAnimating ? arrowColor + ' disableArrow' : arrowColor} />,
    prevArrow: <SliderPrevArrow className='iconImage' color={isAnimating ? arrowColor + ' disableArrow' : arrowColor} />,
    beforeChange: beforeChangeHandler,
    afterChange: afterChangeHandler,
    swipe: !isAnimating,
    onInit: () => {
      setTimeout(() => {
        setIsAnimating(false)
      }, 6000)
    },
    onEdge: (index) => {
      index === 'right' ? slider.current.slickPrev() : slider.current.slickNext()
    }
  }
  return (
    <Slider ref={slider} id='testId' {...settings} className='whatToExpectSlider'>
      {carouselItems?.map((item, index) => (
        <div key={index}>
          <div className='carouselDivScreen' style={{ backgroundColor: item.screenBgColor }}>
            <StyledCloseIcon
              className='CloseContainer'
              $isIcon={true}
              $textColor={item.closeIconColor}
              onClick={() => {
                onClose(index)
              }}
            />
            <div className='carouselDivTop'>
              <h2 className='screenTitle' style={{ color: item.screenTitleColor }}>
                {item.screenTitle}
              </h2>
              <div className='columnContainer'>
                {item.cardItems.cards.map((card, cardIndex) => (
                  // <div>
                  <div key={cardIndex} className={`carouselItemIcon ${animationClass}`} style={{ animationDelay: `${cardIndex * 2}s` }}>
                    {card.icon}
                    <p className='carouselTitle' style={{ color: card.color }}>
                      {card.title}
                    </p>
                    <p className='carouselDesc' style={{ color: card.color, lineHeight: i18n.language === 'es-MX' && '1.5em' }}>
                      {card.desc}
                    </p>
                  </div>
                  // </div>
                ))}
              </div>
            </div>
            <div className={`bottomContent ${animationClass}`}>
              <p className='bottomTitle'>{item.proTipItem.title}</p>
              <div className='bottomItem'>
                <div className='bottomDescIcon'>{item.proTipItem.icon}</div>
                <p className='bottomDesc'>{item.proTipItem.desc}</p>
              </div>
            </div>
          </div>
        </div>
      ))}
    </Slider>
  )
}

const mapStateToProps = (state) => ({
  donor: state.donors.donors?.data,
  loyaltyGameDataSuccess: state.loyalty?.getLoyaltyGameDataSuccess
})

const mapDispatchToProps = (dispatch) => ({
  updateLoyaltyGameData: (donorSfid, data) => dispatch(loyaltyActions.updateLoyaltyGameData(donorSfid, data))
})

export default connect(mapStateToProps, mapDispatchToProps)(LoyaltyGameWhatToExpectModal)
